import { useEffect } from "react";
import UserOrderRow from "./UserOrderRow"
import { i18n } from '../../lang/i18n';
import { ordersLoad } from "../../store/UserData/UserData";
import { NavLink } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/hooks";


export default function TabOrders() {
    const dispatch = useAppDispatch()
    const userData = useAppSelector((state) => state.userData)
    const productExtras = useAppSelector((state) => state.appData.productExtras)
    
    useEffect(() => {
        const timer = setInterval(() => {
            ordersRefresh()
        }, 30000);
        return () => clearInterval(timer);
    });
    async function ordersRefresh() {
        await ordersLoad(dispatch)
    }
    const orders = userData.orders
    return (<>
        <div className="box p-3">
            <div className="row">
                <div className="col-12 text-center"><h4>{i18n.TabOrders.Subtitle}</h4></div>
                <br/>
            </div>
        </div>
        {orders.length === 0 && <>
            <div className="box text-center pt-5 pb-5"><p>{i18n.TabOrders.NoPendingOrders}</p></div>
            <div className="box">
                <br />
                <div className="container main-subtitle mt-1">
                    <NavLink to="/" className="btn-back link-btn"> <i className="fa fa-home" />{i18n._Labels.SeeProducts}</NavLink>
                </div>
                <br />
            </div>
        </>}
        {orders.length > 0 && <div className="home-orders">
            <div className="home-order-title">
                <div className="title">{i18n._Labels.Orders} ({orders.length})</div>
            </div>
            <div>
                <ul className="list-group">
                    {orders.map((item, index) => (
                        <UserOrderRow key={index} order={item} productExtras={productExtras} showDetails={orders.length === 1} onClose={ordersRefresh} />
                    ))}
                </ul>
            </div>
            <div className="row" onClick={ordersRefresh}>
                <div className="col text-center p-3 mt-3"><span ><i className="fa fa-refresh"></i></span></div>
            </div>
        </div>}
    </>
    )
}